// extracted by mini-css-extract-plugin
export default {"avatar":"avatar_avatar__btgiP","default":"avatar_default__Xubx0","green":"avatar_green__kUWll"};